import * as views from "../views";
import EmptyView from "@/core/components/EmptyView.vue";
import { i18nFormat } from "@/i18n.js";

export default [
  {
    path: "analytics",
    component: EmptyView,

    children: [
      {
        path: "experiments", // options: "experiments", "abtesting"
        component: EmptyView,
        children: [
          {
            path: "",
            name: "ABTesting",
            component: views.ABTesting,
            meta: {
              headerVisible: true,
              headerTitle: i18nFormat("t", "analytic.ab.title"),
              headerDescription: i18nFormat("t", "analytic.ab.description"),
              headerDomain: null,
              blockWhenNoPermission: false
            }
          },
          {
            path: ":id", // maybe "experiments" instead
            name: "CampaignDetail",
            component: views.CampaignDetail,
            meta: {
              headerVisible: true,
              headerTitle: i18nFormat("t", "analytic.ab.title"),
              headerDescription: i18nFormat("t", "analytic.ab.description"),
              headerDomain: null,
              blockWhenNoPermission: false
            }
          },
          {
            path: ":id/report",
            name: "CampaignReport",
            component: views.CampaignReport,
            meta: {
              headerVisible: true,
              headerTitle: i18nFormat("t", "analytic.ab.title"),
              headerDescription: i18nFormat("t", "analytic.ab.description"),
              headerDomain: null,
              blockWhenNoPermission: false
            }
          },
          // {
          //   path: "create",
          //   name: "CollectionPagesTemplate",
          //   component: views.PageTemplate,
          //   props: {
          //     type: "collectionpages"
          //   },
          //   meta: {
          //     headerVisible: false,
          //     headerTitle: i18nFormat("t", "page.btnCreate.title", {
          //       type: i18nFormat("tc", "page.collectionpages")
          //     }),
          //     headerDescription: i18nFormat("t", "page.collectionpagesDescription"),
          //     headerDomain: null,
          //     blockWhenNoPermission: true
          //   }
          // }
        ]
      }
    ]
  },
];
